import { RequestedGender } from './types';

// Also keyed in bookings-checkout-viewer and bookings-catalog; keep identical.

export const GENDER_FILTER_OPTION_KEYS: Record<RequestedGender, string> = {
  [RequestedGender.ANY_FEMALE]: 'filter.staff-gender.any-female',
  [RequestedGender.ANY_MALE]: 'filter.staff-gender.any-male',
};

/**
 * The full phrase, for the places that name the choice rather than offer it as
 * a chip. The `summary.` variants of these keys are lower case on purpose —
 * the preferences modal renders those after a "With" prefix, while everywhere
 * here has no prefix and sits the phrase beside real staff names.
 */
export const ANY_GENDER_STAFF_LABEL_KEYS: Record<RequestedGender, string> = {
  [RequestedGender.ANY_FEMALE]:
    'services-preferences-modal.select-any-female-staff',
  [RequestedGender.ANY_MALE]:
    'services-preferences-modal.select-any-male-staff',
};
